import Vue from 'vue';
import VueI18n from 'vue-i18n';


Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'en',
    messages: {
        en: {
            message: {
                loginButton: 'Visit map',
                logoutButton: 'Leave session',
                goMap: 'Visit map',
                searchPlaceholder: 'Search for address',
                settings: 'Settings',
                isNeeded: 'This field is required',
                inValidApiKey: 'Please enter a valid TomTom Map Key',
                inValidPanoramaKey: 'Please enter a valid Panorama Key',
                backToSearch: 'Go back to search results',
                apiKeyView: 'TomTom Map Key',
                momaKeyView: 'Mobile Mapping Services Key',
                togglePanoramas: 'Toggle panoramas',
                couldNotFind: 'We could not find',
                checkSpelling: 'Check your spelling or try adding a city or postcode.',
                miniatureError: 'Panoramic image is temporarily unavailable, please try again in a moment.',
            },
        },
        pl: {
            message: {
                loginButton: 'Zaloguj',
                logoutButton: 'Wyloguj',
                goMap: 'Idź do mapy',
                searchPlaceholder: 'Szukaj adresu',
                settings: 'Ustawienia',
                isNeeded: 'To pole jest wymagane',
                inValidApiKey: 'Proszę wprowadź poprawny TomTom Klucz Map',
                inValidPanoramaKey: 'Proszę wprowadź poprawny Klucz Panoramy',
                backToSearch: 'Wróć do wyszukiwania',
                apiKeyView: 'TomTom Klucz Map',
                momaKeyView: 'Klucz Mobile Mapping Services',
                togglePanoramas: 'Włącz/wyłącz panoramy',
                couldNotFind: 'Nie można odnaleźć',
                checkSpelling: 'Sprawdź pisownię albo spróbuj dodać miasto lub kod pocztowy.',
                miniatureError: 'Panorama jest tymczasowo niedostępna, prosimy spróbować później.',
            },
        },
    },
});


export default i18n;
